module.exports = __webpack_public_path__ + "static/logo-f6b16ae800204d7752a0f9fe5e52f26b.png";